"use client"

import { useEffect, useState } from "react"
import { Alert, AlertDescription } from "@/components/ui/alert"
import { WifiOff, Wifi } from "lucide-react"

export function OfflineIndicator() {
  const [isOnline, setIsOnline] = useState(true)
  const [showOfflineAlert, setShowOfflineAlert] = useState(false)

  useEffect(() => {
    const updateOnlineStatus = () => {
      const online = navigator.onLine
      setIsOnline(online)

      if (!online) {
        setShowOfflineAlert(true)
      } else if (showOfflineAlert) {
        // オンラインに復帰した時は3秒後に非表示
        setTimeout(() => setShowOfflineAlert(false), 3000)
      }
    }

    // 初期状態をチェック
    updateOnlineStatus()

    window.addEventListener("online", updateOnlineStatus)
    window.addEventListener("offline", updateOnlineStatus)

    return () => {
      window.removeEventListener("online", updateOnlineStatus)
      window.removeEventListener("offline", updateOnlineStatus)
    }
  }, [showOfflineAlert])

  if (!showOfflineAlert) return null

  return (
    <Alert
      className={`fixed top-4 left-4 right-4 z-50 ${isOnline ? "border-green-200 bg-green-50" : "border-orange-200 bg-orange-50"}`}
    >
      <div className="flex items-center gap-2">
        {isOnline ? <Wifi className="h-4 w-4 text-green-600" /> : <WifiOff className="h-4 w-4 text-orange-600" />}
        <AlertDescription className={isOnline ? "text-green-800" : "text-orange-800"}>
          {isOnline
            ? "インターネット接続が復旧しました"
            : "オフラインです。基本機能は利用できますが、注文確定はオンライン時のみ可能です"}
        </AlertDescription>
      </div>
    </Alert>
  )
}
